import React from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import DeleteButton from '../Buttons/DeleteButton';
import DiscardButton from '../Buttons/DiscardButton';

interface ReusableModalProps {
    show: boolean;
    onHide: () => void;
    onSubmit: (e?: any) => void;
    title?: string;
    description?: string;
}

const ReusableModal: React.FC<ReusableModalProps> = ({ show, onHide, onSubmit, title, description }) => (
    <Modal show={show} onHide={onHide} centered>
        <div className="st-delete-modal-stripe" />
        <Modal.Header className="st-delete-modal-header">
            <div className="st-delete-modal-header-inner">
                <div className="st-delete-modal-icon-badge">
                    <FontAwesomeIcon icon={faTrash} className="st-delete-modal-icon" />
                </div>
                <span className="st-delete-modal-title">{title}</span>
            </div>
        </Modal.Header>
        {description && (
            <Modal.Body className="st-delete-modal-body">
                <p className="st-delete-modal-description">{description}</p>
            </Modal.Body>
        )}
        <Modal.Footer className="st-delete-modal-footer">
            <DiscardButton onClick={onHide} />
            <DeleteButton onClick={onSubmit} />
        </Modal.Footer>
    </Modal>
);

export default ReusableModal;
